import OrigenDeudaForm from './OrigenDeudaForm'
export {OrigenDeudaForm}
export default OrigenDeudaForm
